import Dialog from "@mui/material/Dialog";
import React, { useContext, useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
//Import from project
import "../../Style/dialogstyle.scss";
import { DELETE_TOPAY_NOTIFICATION } from "../../Schema/ToPayInvoice";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function DeleteToPayNotification({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);

  const [deleteToPayNotification] = useMutation(DELETE_TOPAY_NOTIFICATION, {
    onCompleted: ({ deleteToPayNotification }) => {
      setLoading(false);
      if (deleteToPayNotification?.status === true) {
        setAlert(true, "success", deleteToPayNotification?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteToPayNotification?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteToPayNotification({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Delete To Pay Notification</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              Do you want to delete this data?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                {t("delete")}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
